export default __webpack_public_path__ + "static/media/cain.6d0b2235.png";